var _mask, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAntigravity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    style: {
      flex: "none",
      lineHeight: 1
    },
    viewBox: "0 0 24 24",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Antigravity") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    height: 23,
    id: "lobe-icons-antigravity-0-_R_0_",
    maskUnits: "userSpaceOnUse",
    width: 24,
    x: 0,
    y: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.751 22.607c1.34 1.005 3.35.335 1.508-1.508C17.73 15.74 18.904 1 12.037 1 5.17 1 6.342 15.74.815 21.1c-2.01 2.009.167 2.511 1.507 1.506 5.192-3.517 4.857-9.714 9.715-9.714 4.857 0 4.522 6.197 9.714 9.715z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#lobe-icons-antigravity-0-_R_0_)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#lobe-icons-antigravity-1-_R_0_)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.018-3.992c-.408 3.591 2.686 6.89 6.91 7.37 4.225.48 7.98-2.043 8.387-5.633.408-3.59-2.686-6.89-6.91-7.37-4.225-.479-7.98 2.043-8.387 5.633z",
    fill: "#FFE432"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#lobe-icons-antigravity-2-_R_0_)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.269 7.747c1.058 4.557 5.691 7.374 10.348 6.293 4.657-1.082 7.575-5.653 6.516-10.21-1.058-4.556-5.691-7.374-10.348-6.292-4.657 1.082-7.575 5.653-6.516 10.21z",
    fill: "#FC413D"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#lobe-icons-antigravity-3-_R_0_)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-12.443 10.804c1.338 4.703 7.36 7.11 13.453 5.378 6.092-1.733 9.947-6.95 8.61-11.652C8.282-.173 2.26-2.58-3.833-.848-9.925.884-13.78 6.1-12.443 10.804z",
    fill: "#00B95C"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#lobe-icons-antigravity-4-_R_0_)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-12.443 10.804c1.338 4.703 7.36 7.11 13.453 5.378 6.092-1.733 9.947-6.95 8.61-11.652C8.282-.173 2.26-2.58-3.833-.848-9.925.884-13.78 6.1-12.443 10.804z",
    fill: "#00B95C"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#lobe-icons-antigravity-5-_R_0_)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-7.608 14.703c3.352 3.424 9.126 3.208 12.896-.483 3.77-3.69 4.108-9.459.756-12.883C2.69-2.087-3.083-1.871-6.853 1.82c-3.77 3.69-4.108 9.458-.755 12.883z",
    fill: "#00B95C"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#lobe-icons-antigravity-6-_R_0_)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.932 27.617c1.04 4.482 5.384 7.303 9.7 6.3 4.316-1.002 6.971-5.448 5.93-9.93-1.04-4.483-5.384-7.304-9.7-6.301-4.316 1.002-6.971 5.448-5.93 9.93z",
    fill: "#3186FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#lobe-icons-antigravity-7-_R_0_)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.572-8.185C.392-3.329 2.778 2.472 7.9 4.771c5.122 2.3 11.042.227 13.222-4.63 2.18-4.855-.205-10.656-5.327-12.955-5.122-2.3-11.042-.227-13.222 4.63z",
    fill: "#FBBC04"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#lobe-icons-antigravity-8-_R_0_)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.267 38.686c-5.277-2.072 3.742-19.117 5.984-24.83 2.243-5.712 8.34-8.664 13.616-6.592 5.278 2.071 11.533 13.482 9.29 19.195-2.242 5.713-23.613 14.298-28.89 12.227z",
    fill: "#3186FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#lobe-icons-antigravity-9-_R_0_)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.71 17.471c-1.413 1.649-5.1.808-8.236-1.878-3.135-2.687-4.531-6.201-3.118-7.85 1.412-1.649 5.1-.808 8.235 1.878s4.532 6.2 3.119 7.85z",
    fill: "#749BFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#lobe-icons-antigravity-10-_R_0_)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.163 9.077c5.81 3.93 12.502 4.19 14.946.577 2.443-3.612-.287-9.727-6.098-13.658-5.81-3.931-12.502-4.19-14.946-.577-2.443 3.612.287 9.727 6.098 13.658z",
    fill: "#FC413D"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#lobe-icons-antigravity-11-_R_0_)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.915 2.684c-1.44 3.473-.97 6.967 1.05 7.804 2.02.837 4.824-1.3 6.264-4.772 1.44-3.473.97-6.967-1.05-7.804-2.02-.837-4.824 1.3-6.264 4.772z",
    fill: "#FFEE48"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 17.587,
    id: "lobe-icons-antigravity-1-_R_0_",
    width: 19.838,
    x: -3.288,
    y: -11.917
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_977_115",
    stdDeviation: 1.117
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 38.565,
    id: "lobe-icons-antigravity-2-_R_0_",
    width: 38.9,
    x: 4.251,
    y: -13.493
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_977_115",
    stdDeviation: 5.4
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 36.517,
    id: "lobe-icons-antigravity-3-_R_0_",
    width: 40.955,
    x: -21.889,
    y: -10.592
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_977_115",
    stdDeviation: 4.591
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 36.517,
    id: "lobe-icons-antigravity-4-_R_0_",
    width: 40.955,
    x: -21.889,
    y: -10.592
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_977_115",
    stdDeviation: 4.591
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 36.595,
    id: "lobe-icons-antigravity-5-_R_0_",
    width: 36.632,
    x: -19.099,
    y: -10.278
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_977_115",
    stdDeviation: 4.591
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 34.087,
    id: "lobe-icons-antigravity-6-_R_0_",
    width: 33.533,
    x: 0.981,
    y: 8.758
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_977_115",
    stdDeviation: 4.363
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 35.276,
    id: "lobe-icons-antigravity-7-_R_0_",
    width: 35.978,
    x: -6.143,
    y: -21.659
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_977_115",
    stdDeviation: 3.954
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 46.523,
    id: "lobe-icons-antigravity-8-_R_0_",
    width: 45.114,
    x: -11.96,
    y: -0.46
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_977_115",
    stdDeviation: 3.531
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 24.054,
    id: "lobe-icons-antigravity-9-_R_0_",
    width: 25.094,
    x: 10.485,
    y: 0.58
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_977_115",
    stdDeviation: 3.159
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 30.007,
    id: "lobe-icons-antigravity-10-_R_0_",
    width: 33.508,
    x: 5.833,
    y: -12.467
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_977_115",
    stdDeviation: 2.669
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 26.151,
    id: "lobe-icons-antigravity-11-_R_0_",
    width: 22.194,
    x: -8.355,
    y: -8.876
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_977_115",
    stdDeviation: 3.303
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntigravity);
export default __webpack_public_path__ + "static/media/antigravity.584cba8dbe2685836b6c2c061f917c88.svg";
export { ForwardRef as ReactComponent };